import { createEventHook, tryOnUnmounted } from '@vueuse/core';
import { onUnmounted } from 'vue';

export const useComponentHook = () => {
  const hook = createEventHook();
  /** 只能放在 setup() 裡面用 */
  const onTriggered = (fn: any) => {
    const { off } = hook.on(fn);
    onUnmounted(off);
  };

  return [hook.trigger, onTriggered];
};

export const useNonComponentHook = () => {
  const hook = createEventHook();
  const onTriggered = (fn: any) => {
    const { off } = hook.on(fn);
    tryOnUnmounted(off);
  };

  return [hook.trigger, onTriggered];
};
